"use client";

import TableOfcontent from "@/components/CKBLexical/Icon/components/TableOfcontent";
import { Local } from "@/i18n/settings";
import { useState } from "react";
import type { PublishedArticleHeading } from "../../../utils/publishedArticle";

/** 静态文章目录组件参数。 */
interface ArticleTableOfContentsProps {
  headings: PublishedArticleHeading[];
  lang: Local;
  title?: string;
}

/** 静态文章目录的多语言文案。 */
const TABLE_OF_CONTENTS_COPY: Record<
  Local,
  { close: string; open: string; title: string }
> = {
  [Local.JA]: { close: "閉じる", open: "開く", title: "目次" },
  [Local.KO]: { close: "닫기", open: "보기", title: "목차" },
  [Local.EN]: { close: "Close", open: "Open", title: "Contents" },
};

/** 渲染不依赖 Lexical 编辑器状态的文章目录。 */
const ArticleTableOfContents = ({
  headings,
  lang,
  title,
}: ArticleTableOfContentsProps) => {
  /** 当前侧边栏目录是否处于展开状态。 */
  const [isOpen, setIsOpen] = useState(true);
  /** 当前语言对应的目录文案。 */
  const copy = TABLE_OF_CONTENTS_COPY[lang];
  /** 切换侧边栏目录的展开状态。 */
  const handleToggle = () => setIsOpen(!isOpen);

  if (!headings.length) return null;

  return (
    <nav
      aria-label={copy.title}
      className="article-sidebar-toc bg-[#FAFAFA] p-[20px]"
    >
      <div className="article-toc-heading">
        <TableOfcontent
          aria-hidden="true"
          className="article-toc-heading-icon"
          focusable="false"
          height={28}
          width={22}
          viewBox="0 0 22 28"
        />
        <strong className="article-toc-heading-title">{copy.title}</strong>
        <button
          aria-controls="article-sidebar-toc-content"
          aria-expanded={isOpen}
          className="article-toc-toggle"
          onClick={handleToggle}
          type="button"
        >
          [{isOpen ? copy.close : copy.open}]
        </button>
      </div>
      {isOpen && (
        <div id="article-sidebar-toc-content">
          {title && <div className="article-sidebar-toc-title">{title}</div>}
          <ol className="article-sidebar-toc-list">
            {headings.map((heading) => (
              <li
                className={`article-sidebar-toc-level-${heading.level}`}
                key={heading.id}
              >
                <a href={`#${heading.id}`}>{heading.text}</a>
              </li>
            ))}
          </ol>
        </div>
      )}
    </nav>
  );
};

export default ArticleTableOfContents;
